
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_7y59r_99",
  "variant-secondary": "awsui_variant-secondary_4c84z_7y59r_168",
  "variant-primary": "awsui_variant-primary_4c84z_7y59r_203",
  "variant-info": "awsui_variant-info_4c84z_7y59r_236",
  "variant-value-large": "awsui_variant-value-large_4c84z_7y59r_271",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_7y59r_303",
  "variant-recovery": "awsui_variant-recovery_4c84z_7y59r_336",
  "button": "awsui_button_4c84z_7y59r_369",
  "color-inverted": "awsui_color-inverted_4c84z_7y59r_404",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_7y59r_425",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_7y59r_432",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_7y59r_438",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_7y59r_444",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_7y59r_451",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_7y59r_458",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_7y59r_465",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_7y59r_472",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_7y59r_479",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_7y59r_487",
  "icon": "awsui_icon_4c84z_7y59r_487"
};
  